<app-multi-select-btn 
    [label]="'Users'"
    [list]="users"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
